import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

import AppLayout from '@/layouts/AppLayout.vue';

import AuthLayout from '@/layouts/AuthLayout.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'roles' },
  },
  {
    name: 'base',
    path: '/',
    component: AppLayout,
    redirect: { name: 'users' },
    children: [
      {
        name: 'settings',
        path: 'settings',
        component: () => import('@/pages/settings/Settings.vue'),
      },
      {
        name: 'users',
        path: 'users',
        component: () => import('@/pages/users/UsersPage.vue'),
      },
      {
        name: 'agreements',
        path: 'agreements',
        component: () => import('@/pages/agreements/AgreementsPage.vue'),
      },
      {
        name: 'subscriptions',
        path: 'subscriptions',
        component: () => import('@/pages/subscriptions/SubscriptionsPage.vue'),
        redirect: '/subscriptions/setting',
        children: [
          {
            name: 'history',
            path: 'history',
            component: () => import('@/pages/subscriptions/HistoryPage.vue'),
          },
          {
            name: 'setting',
            path: 'setting',
            component: () => import('@/pages/subscriptions/SettingsPage.vue'),
          }
        ],
      },
    ],
  },
  {
    path: '/login',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: '',
        component: () => import('@/pages/auth/Login.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('@/pages/404.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' };
    } else {
      window.scrollTo(0, 0);
    }
  },
  routes,
});

export default router;
